<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication--Front-Matter-">Here’s to Iowa, and Minnesota, and Nebraska, and</p>
<p class="ORIM-Dedication--Front-Matter-">all the well-meaning people who raised us. We love them</p>
<p class="ORIM-Dedication--Front-Matter-">even as they cast us into the flames.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled119.vue?6689e3b6